import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import ProfileForm from "components/Profile/Profile";
import ChangePasswordForm from "components/Authorization/ChangePassword/ChangePassword.jsx";
import actions from "actions";
import constants from "constants";
import validator from "services/validator.js";
import moment from "moment";

const { ERROR_TYPE_USER_UPDATE_ERROR, CHANGE_PASSWORD_SAGA } = constants;

const {
  loadCurrentUser,
  updateUserSaga,
  addValidateError,
  cleanErrors,
  changePasswordSaga,
  loadDisciplinesSaga,
  loadNewDisciplinesSaga,
  sendConfirmationUsersSaga,
} = actions;

const userRoles = {
  gp: 0,
  gp_trainee: 1,
  nurse: 2,
  consultant: 3,
  hospital_doctor: 4,
  nurse_specialist: 6,
  allied_healthcare_professional: 7,
  pharmacist: 9,
  // midwifery: 11,
  // registered_general_nurses: 12,
};

const disciplineNumberByRole = {
  gp: 1,
  gp_trainee: 1,
  nurse: 1,
  consultant: 5,
  hospital_doctor: 5,
  nurse_specialist: 5,
  allied_healthcare_professional: 1,
  pharmacist: 9,
  // midwifery: 1,
  registered_general_nurses: 1,
};

class Profile extends Component {
  constructor(props) {
    super(props);
    const user = this.props.user;
    this.fillProfileNotificationId = null;
    this.fillProfileDisciplinesNotificationId = null;
    this.state = {
      user: {
        ...user,
        first_name: "",
        last_name: "",
        email: "",
        user_type: "",
        phone: null,
        imc: "",
        pin_number: "",
        registration: "",
        county: "",
        practice_name: "",
        hospital: "",
        role: "",
        title: "",
        ipna_member: false,
        accreditation: false,
        registration_number: "",
        // county: '',
        branch: "",
        ...user,
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        disciplines: [],
        new_disciplines: [],
        new_user_type: "",
        company_name: (user && user.company_name) || "",
        position: (user && user.position) || "",
      },
      passwordChange: {
        id: user.id,
        email: user.email,
        password: "",
        password_confirmation: "",
        old_password: "",
      },
      passwordVisibility: {
        password: false,
        password_confirmation: false,
        old_password: false,
      },
      buttonUserTypeAndDisciplinesConfirmationDisabled: false,
      buttonIpnaConfirmationDisabled: false,
      approveIpna: {
        ipna: false,
        branch: "",
      },
    };
  }

  componentWillMount() {
    this.props.loadCurrentUser();
    this.props.cleanErrors();
    this.props.cleanErrorsPasswordChange();
    // this.setState(prev => {
    //   let disciplines = []
    //   if(this.props.user.disciplines && this.props.user.disciplines.length > 0) disciplines = [...this.props.user.disciplines]
    //   else if(['gp', 'gp_trainee', 'practice_nurse'].indexOf(this.props.user.user_type) > -1) disciplines = [{value: 276}]
    //   return {
    //     ...prev,
    //     user: {
    //       ...this.props.user,
    //       disciplines
    //     }
    //   }
    // });
    this.setState({
      user: {
        ...this.props.user,
        company_name:
          (this.props.user && this.props.user.company_name) || "",
        position:
          (this.props.user && this.props.user.position) || "",
      },
    });
    this.setState({
      approveIpna: {
        ipna: this.props.user && this.props.user.ipna_member,
        branch: this.props.user && this.props.user.branch,
      },
    });
    this.props.loadDisciplines(
      userRoles[this.props.user && this.props.user.user_type],
    );
    this.notifyAccountFill();
  }

  componentWillUnmount() {
    this.closeAccountFillNotification();
  }

  componentWillReceiveProps(nextProps) {
    this.setDisciplinesForGPAndPracticeNurse(
      this.state.user && this.state.user.user_type,
      nextProps.disciplines,
    );
    this.setDisciplinesForPharmacist(
      this.state.user && this.state.user.user_type,
      nextProps.disciplines,
    );
    nextProps.user.is_valid && this.closeAccountFillNotification();
  }

  setDisciplinesForGPAndPracticeNurse = (userType, disciplines) => {
    if (userRoles[userType] < 2) {
      this.setState({
        user: {
          ...this.state.user,
          disciplines: [disciplines[0]],
        },
      });
    }
  };

  setDisciplinesForPharmacist = (userType, disciplines) => {
    if (userRoles[userType] === 9) {
      this.setState({
        user: {
          ...this.state.user,
          disciplines: [disciplines[0]],
        },
      });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.user.ipna_member === true && !this.state.user.branch) {
      toast.warning("Branch required.");
      return;
    }

    // if (this.state.user.accreditation === false && !this.state.user.registration) {
    //   toast.warning('Accreditation number required.')
    //   return;
    // }
    if (this.state.user.accreditation === false && !this.state.user.country) {
      toast.warning("Country required.");
      return;
    }
    if (
      this.state.user.accreditation === true &&
      (this.state.user.user_type === "nurse_specialist" ||
        this.state.user.user_type === "allied_healthcare_professional") &&
      !this.state.user.registration
    ) {
      toast.warning("Accreditation number required.");
      return;
    }
    if (
      this.state.user.accreditation === true &&
      (this.state.user.user_type === "gp" ||
        this.state.user.user_type === "gp_trainee" ||
        this.state.user.user_type === "consultant" ||
        this.state.user.user_type === "hospital_doctor") &&
      !this.state.user.imc
    ) {
      toast.warning("IMC number required.");
    }
    if (
      !this.state.user.pin_number &&
      (this.state.user.user_type === "nurse" ||
        this.state.user.user_type === "nurse_specialist")
    ) {
      toast.warning("NMBI PIN Number required.");
      return;
    }
    if (
      !this.state.user.registration_number &&
      this.state.user.user_type === "pharmacist"
    ) {
      toast.warning("Registration Number required.");
      return;
    }
    if (this.state.user.user_type === "industry") {
      if (!(this.state.user.company_name || "").trim()) {
        toast.warning("Company name is required.");
        return;
      }
      if (!(this.state.user.position || "").trim()) {
        toast.warning("Position/role in the company is required.");
        return;
      }
    }
    if (
      this.state.user.user_type != "sponsor" &&
      this.state.user.user_type !== "industry" &&
      !(this.state.user.disciplines && this.state.user.disciplines.length)
    ) {
      toast.warning("Disciplines required");
      return;
    }

    const userData = {
      ...this.state.user,
      ...(this.state.user.disciplines && this.state.user.disciplines.length
        ? {
            disciplines: this.state.user.disciplines.map(
              (d) => d.value || d.id || d,
            ),
          }
        : {}),
    };
    this.setState({ user: userData });
    this.props.updateUser(userData);
  };

  onSubmitPasswordChange = (e) => {
    e.preventDefault();
    this.props.changePassword(this.state.passwordChange);
  };

  onFieldChange = (e) => {
    const userData = {
      ...this.state.user,
      [e.target.name]: e.target.value,
    };

    if (e.target.name === "user_type") {
      this.props.loadDisciplines(userRoles[e.target.value]);
      if (["gp", "gp_trainee", "nurse"].indexOf(e.target.value) > -1) {
        userData.disciplines = [{ value: 276 }];
      } else {
        userData.disciplines = [];
      }
    }

    if (e.target.name === "new_user_type") {
      this.props.loadNewDisciplines(userRoles[e.target.value]);
      userData.new_disciplines = [];
    }

    this.setState({ user: userData });
  };
  onSelectChangeDiscipline = (disciplines) => {
    const disciplineIds = this.state.user.disciplines;
    const userType = this.state.user && this.state.user.user_type;
    const isRemoveDiscipline =
      (disciplines && disciplines.length) <
      ((disciplineIds && disciplineIds.length) || 0);
    const isUserRoleGPOrPracticeNurse = userRoles[userType] < 2;

    if (
      !isRemoveDiscipline &&
      disciplineNumberByRole[userType] <=
        ((disciplineIds && disciplineIds.length) || 0)
    ) {
      return;
    }

    if (isRemoveDiscipline && isUserRoleGPOrPracticeNurse) {
      return;
    }

    this.onFieldChange({
      target: {
        name: "disciplines",
        value: disciplines,
      },
    });

    this.closeAccountFillDisciplinesNotification();
  };

  onSelectChangeNewDiscipline = (disciplines = []) => {
    const disciplineIds = this.state.user.new_discipliness || [];
    const isRemoveDiscipline =
      (disciplines && disciplines.length) <
      ((disciplineIds && disciplineIds.length) || 0);

    if (
      !isRemoveDiscipline &&
      disciplineNumberByRole[this.state.user.new_user_type] <=
        ((disciplineIds && disciplineIds.length) || 0)
    ) {
      return;
    }

    this.onFieldChange({
      target: {
        name: "new_disciplines",
        value: (disciplines || []).map((discipline) => discipline.value),
      },
    });
  };

  onNewDisciplinesApprove = () => {
    if (!this.state.user.new_user_type) {
      toast.warning("User type is required");
      return;
    }
    this.props.sendConfirmationUsers(this.state.user);
    toast.warning(
      "Request sent to admin for review. Please allow for 24 hours for changes to be applied.",
    );
    this.setState({ buttonUserTypeAndDisciplinesConfirmationDisabled: true });
  };

  onIpnaApprove = () => {
    if (
      this.state.approveIpna.ipna !== false &&
      !this.state.approveIpna.branch
    ) {
      toast.warning("Branch is required");
      return;
    }

    this.props.sendConfirmationIpna(this.state.approveIpna);
    toast.warning(
      "Request sent to admin for review. Please allow for 24 hours for changes to be applied.",
    );
    this.setState({ buttonIpnaConfirmationDisabled: true });
  };

  onPasswordChangeVisibility = (field, value) => {
    this.setState({
      passwordVisibility: {
        ...this.state.passwordVisibility,
        [field]: value,
      },
    });
  };

  onPasswordsFieldChange = (e) => {
    const passwordChangeData = {
      ...this.state.passwordChange,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    this.setState({ passwordChange: passwordChangeData }); //, this.validatePasswordChange);
  };

  onRoleChange = (e) => {
    this.onFieldChange(e);
    // const userData = {
    //   ...this.state.user,
    //   ...{ user_type: e.target.value }
    // }
    // this.setState({ user: userData });
  };

  validateUser = () => {
    this.props.validateUser(validator.validate(this.state.user, "userProfile"));
  };

  validatePasswordChange = () => {
    this.props.validatePasswordChange(
      validator.validate(this.state.passwordChange, "newPassword"),
    );
  };

  onCountyChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ county: e.value },
    };
    this.setState({ user: userData });
  };

  onIpnaChange = (event) => {
    if (!(event.target.value == "true")) {
      const userData = {
        ...this.state.user,
        ...{
          ipna_member: event.target.value == "true",
          branch: null,
        },
      };
      this.setState({ user: userData });
    } else {
      const userData = {
        ...this.state.user,
        ...{
          ipna_member: event.target.value == "true",
        },
      };
      this.setState({ user: userData });
    }
  };

  onApproveIpnaChange = (event) => {
    if (!(event.target.value == "true")) {
      const ipnaData = {
        ...this.state.approveIpna,
        ...{
          ipna: event.target.value == "true",
          branch: null,
        },
      };
      this.setState({ approveIpna: ipnaData });
    } else {
      const ipnaData = {
        ...this.state.approveIpna,
        ...{
          ipna: event.target.value == "true",
        },
      };
      this.setState({ approveIpna: ipnaData });
    }
  };

  onAccreditaionChange = (event) => {
    if (event.target.value == "true") {
      const userData = {
        ...this.state.user,
        ...{
          accreditation: event.target.value == "true",
          country: null,
        },
      };
      this.setState({ user: userData });
    } else {
      const userData = {
        ...this.state.user,
        ...{
          accreditation: event.target.value == "true",
        },
      };
      this.setState({ user: userData });
    }
  };

  onCountryChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        country: status.value,
      },
    };

    this.setState({ user: userData });
  };

  onBranchChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        branch: status.value,
      },
    };

    this.setState({ user: userData });
  };

  onApproveIpnaBranchChange = (status) => {
    const ipnaData = {
      ...this.state.approveIpna,
      ...{
        branch: status.value,
      },
    };

    this.setState({ approveIpna: ipnaData });
  };

  irishRoleFields = () => {
    switch (this.state.user.user_type) {
      case "gp":
        return ["imc", "practice_name"];
      case "gp_trainee":
        return ["imc", "practice_name"];
      case "consultant":
        return ["imc", "hospital"];
      case "hospital_doctor":
        return ["imc", "hospital"];
      // case "practice_nurse":
      //   return ["pin_number", "practice_name"];
      case "nurse_specialist":
        return ["registration", "pin_number"];
      case "nurse":
        return ["practice_name", "pin_number"];
      case "allied_healthcare_professional":
        return ["registration", "profession", "practice_name"];
      case "pharmacist":
        return ["registration_number"];
      case "midwifery":
        return ["pin_number"];
      case "registered_general_nurses":
        return ["pin_number"];
      case "industry":
        return ["company_name", "position"];
      default:
        return [];
    }
  };

  internationRoleFields = () => {
    switch (this.state.user.user_type) {
      case "gp":
        return ["registration", "practice_name"];
      case "gp_trainee":
        return ["registration", "practice_name"];
      case "consultant":
        return ["registration", "hospital"];
      case "hospital_doctor":
        return ["registration", "hospital"];
      // case "practice_nurse":
      //   return ["pin_number", "practice_name"];
      case "nurse_specialist":
        return ["registration", "pin_number"];
      case "nurse":
        return ["practice_name", "pin_number"];
      case "allied_healthcare_professional":
        return ["profession", "registration", "practice_name"];
      case "pharmacist":
        return ["registration_number"];
      case "midwifery":
        return ["pin_number"];
      case "registered_general_nurses":
        return ["pin_number"];
      case "industry":
        return ["company_name", "position"];
      default:
        return [];
    }
  };

  notifyAccountFill = () => {
    if (this.props.user.is_valid == false) {
      this.fillProfileNotificationId = toast.warn(
        "Please complete your profile",
        {
          autoClose: false,
        },
      );
      this.pressUpdateNotificationId = toast.warn(
        "Please, press 'update' to update your profile",
        {
          autoClose: false,
        },
      );
    }
    const isGpUsers =
      ["gp", "gp_trainee", "nurse", "practice_nurse", "pharmacist"].indexOf(
        this.props.user_type,
      ) === -1;

    if (
      !(this.props.user.disciplines && this.props.user.disciplines.length) &&
      !isGpUsers
    ) {
      this.fillProfileDisciplinesNotificationId = toast.warn(
        "Please fill in disciplines",
        {
          autoClose: false,
        },
      );
    }
  };

  closeAccountFillNotification = () => {
    this.fillProfileNotificationId &&
      toast.dismiss(this.fillProfileNotificationId);
    this.pressUpdateNotificationId &&
      toast.dismiss(this.pressUpdateNotificationId);
  };

  closeAccountFillDisciplinesNotification = () => {
    this.fillProfileDisciplinesNotificationId &&
      toast.dismiss(this.fillProfileDisciplinesNotificationId);
  };

  render() {
    const {
      errors,
      errorsFrontend,
      passwordChangeErrors,
      passwordChangeErrorsFrontend,
    } = this.props;

    const outErrors = Object.keys(errorsFrontend || {}).length
      ? errorsFrontend
      : errors;
    const outErrorsPasswordChange = Object.keys(
      passwordChangeErrorsFrontend || {},
    ).length
      ? passwordChangeErrorsFrontend
      : errors;
    return (
      <main className="site--width">
        <h2 className="main_title">PROFILE</h2>
        <ProfileForm
          userProps={this.props.user}
          user={this.state.user}
          approveIpna={this.state.approveIpna}
          onFieldChange={this.onFieldChange}
          onSubmit={this.onSubmit}
          errors={outErrors || {}}
          onRoleChange={this.onRoleChange}
          onCountyChange={this.onCountyChange}
          onIpnaChange={this.onIpnaChange}
          onApproveIpnaChange={this.onApproveIpnaChange}
          onBranchChange={this.onBranchChange}
          onApproveIpnaBranchChange={this.onApproveIpnaBranchChange}
          onCountryChange={this.onCountryChange}
          onAccreditaionChange={this.onAccreditaionChange}
          irishRoleFields={this.irishRoleFields()}
          internationRoleFields={this.internationRoleFields()}
          is_admin={false}
          onSelectChangeDiscipline={this.onSelectChangeDiscipline}
          onSelectChangeNewDiscipline={this.onSelectChangeNewDiscipline}
          onNewDisciplinesApprove={this.onNewDisciplinesApprove}
          onIpnaApprove={this.onIpnaApprove}
          disciplines={this.props.disciplines}
          newDisciplines={this.props.newDisciplines}
          buttonUserTypeAndDisciplinesConfirmationDisabled={
            this.state.buttonUserTypeAndDisciplinesConfirmationDisabled
          }
          buttonIpnaConfirmationDisabled={
            this.state.buttonIpnaConfirmationDisabled
          }
        />

        <h2 className="main_title" id="change_password">
          CHANGE PASSWORD
        </h2>
        <ChangePasswordForm
          user={this.state.passwordChange}
          onFieldChange={this.onPasswordsFieldChange}
          onSubmit={this.onSubmitPasswordChange}
          errors={outErrorsPasswordChange || {}}
          passwordVisibility={this.state.passwordVisibility}
          onPasswordChangeVisibility={this.onPasswordChangeVisibility}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ERROR_TYPE_USER_UPDATE_ERROR],
  errorsFrontend: state.errors[`${ERROR_TYPE_USER_UPDATE_ERROR}_FRONTEND`],
  user: state.users.user,
  passwordChangeErrors: state.errors[CHANGE_PASSWORD_SAGA],
  passwordChangeErrorsFrontend:
    state.errors[`${CHANGE_PASSWORD_SAGA}_FRONTEND`],
  disciplines: state.disciplines.list.values,
  count: state.disciplines.list.count,
  total_pages: state.disciplines.list.total_pages,
  page: state.disciplines.list.page,
  query: state.disciplines.list.query,
  newDisciplines: state.disciplines.newDisciplines.values,
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: () => dispatch(loadCurrentUser()),
  updateUser: (user) => dispatch(updateUserSaga(user)),
  validateUser: (errors) =>
    dispatch(addValidateError(ERROR_TYPE_USER_UPDATE_ERROR, errors)),
  cleanErrors: () => dispatch(cleanErrors(ERROR_TYPE_USER_UPDATE_ERROR)),
  validatePasswordChange: (errors) =>
    dispatch(addValidateError(CHANGE_PASSWORD_SAGA, errors)),
  cleanErrorsPasswordChange: () => dispatch(cleanErrors(CHANGE_PASSWORD_SAGA)),
  changePassword: (changePasswordData) =>
    dispatch(changePasswordSaga(changePasswordData)),
  loadDisciplines: (userType) =>
    dispatch(loadDisciplinesSaga(1, { discipline_type: userType })),
  loadNewDisciplines: (userType) =>
    dispatch(loadNewDisciplinesSaga(1, { discipline_type: userType })),
  sendConfirmationUsers: (user) =>
    dispatch(
      sendConfirmationUsersSaga({
        confirmation_users: {
          new_disciplines: user.new_disciplines,
          new_user_type: userRoles[user.new_user_type],
          confirmation_type: 0,
        },
      }),
    ),
  sendConfirmationIpna: (approveIpna) =>
    dispatch(
      sendConfirmationUsersSaga({
        confirmation_users: {
          ipna: approveIpna.ipna,
          branch: approveIpna.branch,
          confirmation_type: 2,
        },
      }),
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/containers/Profile/Profile.js